import { configureStore } from '@reduxjs/toolkit';

import reducersObj from './slices';
import merchantReducer from './slices/merchantSlice';
import {
  TypedUseSelectorHook,
  useSelector as useReduxSelector,
} from 'react-redux';
import {
  FLUSH,
  PAUSE,
  PERSIST,
  persistCombineReducers,
  persistReducer,
  persistStore,
  PURGE,
  REGISTER,
  REHYDRATE,
} from 'redux-persist';
import autoMergeLevel2 from 'redux-persist/es/stateReconciler/autoMergeLevel2';
import storage from 'redux-persist/lib/storage';
import { RootState } from '../types';

const persistConfig = {
  key: 'root',
  storage,
  timeout: 5000,
  stateReconciler: autoMergeLevel2,
  version: 1,
  blacklist: ['client'],
};

const merchantPersistConfig = {
  key: 'merchant-state',
  storage,
  blacklist: ['isLoading', 'error'],
};

const persistedReducer = persistCombineReducers(persistConfig, {
  ...reducersObj,
  merchant: persistReducer(merchantPersistConfig, merchantReducer),
});

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware({
      serializableCheck: {
        /* Ignore persistance actions */
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    });
  },
});

export const persistor = persistStore(store);

export const useAppSelector: TypedUseSelectorHook<RootState> = useReduxSelector;

export const dispatch = store.dispatch;
